<template>
  <div class="flex items-center">
    <slot></slot>
    <q-btn
      class="filter-icon q-ml-auto btn--no-hover"
      :class="{ active: showFilters }"
      icon="filter_alt"
      flat
      :ripple="false"
      @click="showFilters = !showFilters"
    >
      <q-tooltip>{{ showFilters ? 'Hide filters' : 'Show filters' }}</q-tooltip>
    </q-btn>
    <q-btn
      v-if="mode === 'read'"
      flat
      size="md"
      style="width: 30px"
      icon="edit"
      class="btn--no-hover"
      @click="goToRegistration($event)"
    >
      <q-tooltip>Edit</q-tooltip>
    </q-btn>
  </div>
  <q-table
    :columns="cols"
    flat
    :rows="rows"
    class="external-dns-table"
    ref="alibabaEnvs"
    row-key="id"
    v-model:pagination="pagination"
    :loading="loading"
    binary-state-sort
    :rows-per-page-options="[5, 7, 10, 15, 20]"
    @request="load"
  >
    <template v-slot:body-cell-actions="props">
      <q-td :props="props">
        <WorkflowsBtn
          @showWorkflow="showWorkflow($event, props.row)"
          :loading="loading"
          :relatedWorkflowStatuses="relatedWorkflowStatuses.find((i) => i.id === props.row.id)?.statuses || []"
        />
        <q-btn
          flat
          round
          size="10px"
          style="width: 30px; height: 40px"
          class="btn--no-hover"
          :ripple="false"
          icon="engp:engp-ico-copy"
          @click.stop="copyUuid(props.row.id)"
        >
          <q-tooltip>Copy uuid</q-tooltip>
        </q-btn>
      </q-td>
    </template>
    <template v-slot:no-data>
      <div class="flex full-width column items-center q-py-lg">
        <q-icon name="mdi-cloud-search" class="q-mb-sm" size="40px" color="primary"></q-icon>
        <span class="block" style="font-size: 14px">No items were found.</span>
      </div>
    </template>
    <template v-slot:body-cell-status="props">
      <q-td style="width: 30px" :props="props">
        <StatusCell v-if="!props.row.deletedAt" :status="props.row.status" />
        <q-icon v-else name="close" color="grey" size="15px"></q-icon>
      </q-td>
    </template>
    <template v-slot:top>
      <div v-if="showFilters" class="row no-wrap full-width q-mt-sm q-mb-xs q-col-gutter-sm">
        <div class="col">
          <q-select
            v-model="filters.status"
            :options="[
              { label: 'Completed', value: 'completed' },
              { label: 'In progress', value: 'inprogress' },
              { label: 'Failed', value: 'failed' },
              { label: 'Removed', value: 'removed' },
            ]"
            emit-value
            map-options
            options-dense
            @update:model-value="filterByStatus"
            label="Status"
            clearable
            outlined
            dense
            class="q-mb-sm"
          ></q-select>
        </div>
        <div class="col">
          <q-input
            v-model="filters.environment"
            label="Environment"
            @update:model-value="filterTable"
            @clear="reloadTable()"
            outlined
            dense
            clearable
            class="q-mb-sm"
          ></q-input>
        </div>
        <div class="col">
          <q-input
            v-model="filters.region"
            label="Region"
            @update:model-value="filterTable"
            @clear="reloadTable()"
            outlined
            dense
            clearable
            class="q-mb-sm"
          ></q-input>
        </div>
        <div class="col">
          <q-input
            v-model="filters.vpcId"
            label="VPC ID"
            @update:model-value="filterTable"
            @clear="reloadTable()"
            outlined
            dense
            clearable
            class="q-mb-sm"
          ></q-input>
        </div>
        <div class="col">
          <q-input
            v-model="filters.subnets"
            label="Subnets"
            @update:model-value="filterTable"
            @clear="reloadTable()"
            outlined
            dense
            clearable
            class="q-mb-sm"
          ></q-input>
        </div>
      </div>
    </template>
  </q-table>
</template>

<script>
import dayjs from 'dayjs';
import emitter from 'tiny-emitter/instance';
import { copyToClipboard } from 'quasar';
import { getAlibabaEnvs, getRelatedWorkflowsStatuses } from '../../api/api';
import StatusCell from '../registration-network/components/StatusCell.vue';
import { supportCntrlClick } from '@/shared/helpers';
import WorkflowsBtn from '@/shared/components/WorkflowsBtn.vue';

export default {
  name: 'AlibabaEnvironments',
  components: {
    StatusCell,
    WorkflowsBtn,
  },
  props: {
    registrationId: {
      type: String,
    },
    registrationData: {
      type: Object,
    },
    mode: {
      type: String,
      default: () => 'read',
    },
  },
  data() {
    return {
      cols: [
        {
          label: 'Status',
          name: 'status',
          field: 'status',
          align: 'center',
        },
        {
          label: 'Environment',
          name: 'environment',
          field: 'environment',
          align: 'left',
        },
        {
          label: 'Region',
          name: 'region',
          field: 'region',
          align: 'left',
        },
        {
          label: 'Account ID',
          name: 'accountId',
          field: 'accountId',
          align: 'center',
        },
        {
          label: 'DGF Case ID',
          name: 'dgfCaseId',
          field: 'dgfCaseId',
          align: 'left',
        },
        {
          label: 'VPC ID',
          name: 'vpcId',
          field: 'vpcId',
          align: 'left',
        },
                {
          label: 'Subnets',
          name: 'subnets',
          field: 'subnets',
          align: 'left',
        },
                {
          label: 'DR VPC ID',
          name: 'drVpcId',
          field: 'drVpcId',
          align: 'left',
        },
                {
          label: 'DR Region',
          name: 'drRegion',
          field: 'drRegion',
          align: 'left',
        },
                        {
          label: 'DR Subnets',
          name: 'drSubnets',
          field: 'drSubnets',
          align: 'left',
        },
        {
          label: 'Created At',
          name: 'createdAt',
          field: 'createdAt',
          align: 'left',
          format: (val) => dayjs(val).format('DD.MM.YYYY HH:mm'),
          sortable: true,
        },
        {
          label: 'Updated At',
          name: 'updatedAt',
          field: 'updatedAt',
          align: 'left',
          format: (val) => dayjs(val).format('DD.MM.YYYY HH:mm'),
          sortable: true,
        },
        {
          label: '',
          name: 'actions',
          field: 'actions',
          align: 'right',
        },
      ],
      rows: [],
      pagination: {
        sortBy: 'createdAt',
        descending: true,
        page: 1,
        rowsPerPage: 5,
      },
      filters: {
        environment: undefined,
        region: undefined,
        subnets: undefined,
        vpcId: undefined,
        status: undefined,
      },
      loading: false,
      showFilters: false,
      timeout: undefined,
      relatedWorkflowStatuses: [],
    };
  },
  methods: {
    copyUuid(uuid) {
      copyToClipboard(uuid).then(() => {
        this.$notify('info', 'Info', 'Environment UUID was copied');
      });
    },
    goToRegistration(event) {
      supportCntrlClick(
        event,
        `/my-portfolio/${this.registrationData.digitalServiceApm}/registration/${this.registrationId}`,
      );
    },
    filterByStatus(value) {
      this.filters.status = value;
      if (value === 'removed') {
        this.cols.splice(6, 0, {
          label: 'Deleted At',
          name: 'deletedAt',
          field: 'deletedAt',
          align: 'left',
          format: (val) => dayjs(val).format('DD.MM.YYYY HH:mm'),
        });
      } else {
        if (this.cols.length === 10) {
          this.cols.splice(6, 1);
        }
      }
      this.reloadTable();
    },
    showWorkflow(event, record) {
      supportCntrlClick(event, `/workflows?itemId=${record.id}`);
    },
    async load(props) {
      this.loading = true;
      try {
        this.relatedWorkflowStatuses = [];
        const limit = props.pagination.rowsPerPage;
        const { sortBy, descending } = props.pagination;
        const skip = props.pagination.page === 1 ? 0 : (props.pagination.page - 1) * props.pagination.rowsPerPage;
        const { environment, region, subnets, vpcId, status } = this.filters;
        const { count, data } = await getAlibabaEnvs(
          this.registrationId,
          limit,
          skip,
          sortBy,
          descending,
          environment,
          region,
          subnets,
          vpcId,
          status,
        );
        this.pagination.rowsNumber = count;
        this.rows = data;
        this.pagination.sortBy = sortBy;
        this.pagination.descending = descending;
        this.pagination.page = props.pagination.page;
        this.pagination.rowsPerPage = props.pagination.rowsPerPage;
        const relatedWorkflowsPrmises = this.rows.map((record) => {
          return getRelatedWorkflowsStatuses(record.id).then((response) => {
            this.relatedWorkflowStatuses.push({ id: record.id, statuses: response });
          });
        });
        await Promise.all([...relatedWorkflowsPrmises]);
      } finally {
        this.loading = false;
      }
    },
    filterTable() {
      this.loading = true;
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        this.reloadTable();
      }, 1500);
    },
    reloadTable() {
      this.$refs.alibabaEnvs.requestServerInteraction();
    },
  },
  mounted() {
    this.reloadTable();
  },
  created() {
    emitter.on('reloadAlibabaEnvs', () => {
      this.reloadTable();
    });
  },
  unmounted() {
    emitter.off('reloadAlibabaEnvs');
  },
};
</script>
